import type { FaireProductEntity } from "../../entity_types/product";

export const p_dq7xq8yxvc: FaireProductEntity = {
  token: "p_dq7xq8yxvc",
  type: "product",
  name: "Bug-Off Lotion Bar, Natural Bug Repellent",
  brandToken: "b_rvn46uxywb",
  brandName: "Holistic Homestead",
  imageUrl:
    "https://cdn.faire.com/fastly/c95b60eea1c80ab935ff2c3138a209d66b9a0cc6e4ede7f7331ead1cbca427c2.jpeg",
  galleryImageUrls: [],
  priceDollars: 7,
  description:
    "This all-natural bug repellent is a customer favorite! It helps keep the bugs at bay while keeping your skin healthy & soft! Infused with bug repelling organic herbs and finished with 100% pure essential oils you will be glad to have this on hand when you venture outdoors. Toss them in your purse, diaper bag, or backpack! Lotion bars are solid at room temp and the warmth from your skin softens them for application. \n\nApply to wrists, ankles, behind the neck, or other exposed areas. Keep away from eyes. Best when used right before heading outside.  Not recommended for children under the age of 2 years old. \n\n1.25 oz. Bar in Tin\n\nIngredients: Coconut Oil*, Lavender*, Lemon Balm Leaf*, Catnip Leaf*, Pure Beeswax, Shea Butter*, Essential Oils (Citronella, Grapefruit Pink, Geranium Bourbon, Rosalina, Patchouli) *Organic",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:38.847Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
